/* Rajat Veda — add to cart from a collection card.
 * Loaded from snippets/meta-tags.liquid (deferred), the one file rendered once on
 * every page of this theme that we can edit.
 *
 * The round + is a small circle drawn on top of a product card. Two things were
 * wrong before this file existed:
 *
 *   1. Hit testing at the centre of the visible circle returns <quick-add-component>,
 *      not the <button> inside it. <product-card> navigates to the product page on
 *      any click whose target is not a button, input, label or select
 *      (navigateToProduct in assets/product-card.js), so clicking the + opened the
 *      product instead of adding. That is what "the button does nothing" was.
 *   2. Relying on the browser's implicit form submit left the add depending on
 *      wiring we could not verify from outside the page.
 *
 * So this takes the click over. Any click inside the wrapper is stopped before the
 * card can act on it, and the add is fired explicitly with requestSubmit(), which
 * raises the same submit event product-form-component already listens for.
 *
 * Capture phase is deliberate: <product-card>'s handler sits between the button
 * and the document, so a bubble listener here would run too late to stop it.
 */
(function () {
  function cartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count; })
      .catch(function () { return null; });
  }

  /* The icon and label are hidden by rv-price.css, and the theme does not leave
     its own added state on the button, so without this a successful add shows
     nothing on the card. Only flips to the tick once the cart really changed. */
  function confirmOnce(button, before) {
    setTimeout(function () {
      cartCount().then(function (after) {
        if (before === null || after === null || after <= before) return;
        button.setAttribute('data-added', 'true');
        setTimeout(function () { button.removeAttribute('data-added'); }, 1600);
      });
    }, 700);
  }

  function fallbackAdd(form, button, before) {
    // Only reached if requestSubmit raised no submit event, i.e. the theme's
    // handler is not listening. Adds through the Cart AJAX API instead.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed: ' + res.status);
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'rv-quickadd' } }));
        confirmOnce(button, before);
      })
      .catch(function (err) { console.warn('[rv-quickadd]', err); });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var wrapper = target.closest('product-card .quick-add');
      if (!wrapper) return;

      var button = wrapper.querySelector('.quick-add__button--add') || wrapper.querySelector('.quick-add__button');
      if (!button || button.disabled) return;

      // Multi-variant products render a Choose button instead, which opens the
      // theme's quick-add modal and has no form. Forward the click and leave it be.
      if (button.classList.contains('quick-add__button--choose')) {
        if (target !== button && !button.contains(target)) {
          event.preventDefault();
          event.stopPropagation();
          button.click();
        }
        return;
      }

      var form = button.form || wrapper.querySelector('form');
      if (!form) return;

      event.stopPropagation();
      event.preventDefault();

      cartCount().then(function (before) {
        var fired = false;
        var mark = function () { fired = true; };
        form.addEventListener('submit', mark, true);

        if (typeof form.requestSubmit === 'function') form.requestSubmit(button);
        else button.click();

        form.removeEventListener('submit', mark, true);

        if (fired) confirmOnce(button, before);
        else fallbackAdd(form, button, before);
      });
    },
    true
  );
})();
